import { Common } from '@stockbit/ui';
import { CounterContainer } from './styled';

const { Text } = Common;

interface ImagesCounterProps {
  current: number;
  total: number;
}

function ImagesCounter({ current, total }: ImagesCounterProps) {
  if (total === 0) {
    return null;
  }
  return (
    <CounterContainer>
      <Text size="12px" height="135%" weight="400">
        {current + 1}/{total}
      </Text>
    </CounterContainer>
  );
}

export default ImagesCounter;
